module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "timeframe"
  }, [(_vm.label) ? _c('span', [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('dropdown', {
    staticClass: "dropdown-s",
    attrs: {
      "select": _vm.startHour,
      "items": _vm.hours,
      "default-value": _vm.defaultValue
    },
    on: {
      "changed": function($event) {
        return _vm.updatePeriod($event, 'hour', 'start')
      }
    }
  }), _vm._v(" "), _c('dropdown', {
    staticClass: "dropdown-s",
    attrs: {
      "select": _vm.startMinute,
      "items": _vm.minutes
    },
    on: {
      "changed": function($event) {
        return _vm.updatePeriod($event, 'minute', 'start')
      }
    }
  }), _vm._v(" "), (!_vm.single) ? _c('span', [_vm._v(_vm._s(_vm.$t('label.until')))]) : _vm._e(), _vm._v(" "), (!_vm.single) ? _c('dropdown', {
    staticClass: "dropdown-s",
    attrs: {
      "select": _vm.endHour,
      "items": _vm.hours
    },
    on: {
      "changed": function($event) {
        return _vm.updatePeriod($event, 'hour', 'end')
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.single) ? _c('dropdown', {
    staticClass: "dropdown-s",
    attrs: {
      "select": _vm.endMinute,
      "items": _vm.minutes
    },
    on: {
      "changed": function($event) {
        return _vm.updatePeriod($event, 'minute', 'end')
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60fc8771","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/global/Timeframe.vue
// module id = 579
// module chunks = 225